/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { InboundContext } from '../../../context/InboundContext';
// import { validateEmail } from '../../../utils/auth-utils';
import { Logo } from '../../common';
import { Button, Heading, Input, Text } from '../../styledComponents';
import { checkApplicationExists } from '../../../services/inbound.service';
import PoweredbySaral from '../../../assets/images/powered-by-saral.svg';
import styles from './ContentContainer.module.css';

type ContentContainerProps = {
  headline: string | undefined;
  description: string | undefined;
  ctaButtonText: string | undefined;
  logoImage: string | undefined;
  colors: { background: string; btnText: string; ctaBtn: string; headline: string; subText: string } | undefined;
  fontStyle: string | undefined;
};

export default function ContentContainer({
  headline,
  description,
  ctaButtonText,
  logoImage,
  colors,
  fontStyle,
}: ContentContainerProps) {
  const [email, setEmail] = useState('');
  const [errorMessage, setErrormessage] = useState('');
  const { setCreatorEmail, setApplicationId, t, formId, subDomainSuffix, setInfluencerAddress } =
    useContext(InboundContext);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.SyntheticEvent<HTMLFormElement>) => {
    e.preventDefault();
    const response = await checkApplicationExists({ email, formId });
    if (response.data.success) {
      setCreatorEmail(email);
      setApplicationId(response.data.applicationId);
      if (response.data.influencerAddress) {
        setInfluencerAddress(response.data.influencerAddress);
      }
      navigate(`/${subDomainSuffix}/creator-form`);
    } else {
      navigate(`/${subDomainSuffix}/already-submitted`);
    }
  };

  const [isFontLoaded, setIsFontLoaded] = useState(false);

  const selectedFont = fontStyle;

  const handleFontSelect = (fontName: string) => {
    const apiUrl = `https://fonts.googleapis.com/css2?family=${fontName.replace(/ /g, '+')}&display=swap`;

    // Inject the font link dynamically
    const link = document.createElement('link');
    link.href = apiUrl;
    link.rel = 'stylesheet';
    document.head.appendChild(link);
    // Check if the font is loaded
    document.fonts
      .load(`1em ${fontName}`)
      .then(() => {
        setIsFontLoaded(true); // Mark font as loaded
      })
      .catch(() => {
        console.error(`Failed to load font: ${fontName}`);
      });
  };

  useEffect(() => {
    handleFontSelect(selectedFont || 'Poppins');
  }, [fontStyle]);

  if (!isFontLoaded) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <></>;
  }

  return (
    <div className={styles.contentContainer} style={{ background: colors?.background }}>
      <div className={styles.logoContainer}>
        <Logo logoUrl={logoImage} isExpanded />
      </div>
      <div className={styles.mainContent}>
        <Heading fontFamily={selectedFont} fontSize="42px" color={colors?.headline}>
          {headline}
        </Heading>
        <Text color={colors?.subText}>{description}</Text>
        <form onSubmit={handleSubmit}>
          <div className={styles.inputContainer}>
            <Input
              type="email"
              placeholder={t('emailPlaceholder')}
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setErrormessage('');
              }}
              required
            />
            <Button type="submit" bgColor={colors?.ctaBtn} color={colors?.btnText}>
              {ctaButtonText}
            </Button>
          </div>
        </form>
        {errorMessage && (
          <Text color="#e64848" fontSize="15px">
            {errorMessage}
          </Text>
        )}
      </div>
      <a href="https://getsaral.com" target="_blank" rel="noreferrer">
        <img src={PoweredbySaral} alt="logo" width={160} />
      </a>
    </div>
  );
}
